import { Pipe, PipeTransform } from '@angular/core';

/**
 * Normalizes invoice note for multiline display: converts <br> variants to newlines.
 * Use with a container that has white-space: pre-line so \n is rendered as line breaks.
 * Handles API returning either "1\n2\n3" (real newlines) or "1<br>2<br>3" (HTML).
 */
@Pipe({ name: 'formatNoteHtml' })
export class FormatNoteHtmlPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (value == null || value === '') return '';
    // Normalize <br>, <br/>, <br /> (and literal \n in JSON strings) to newline
    return value
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/\\n/g, '\n');
  }
}
